class CountrySelector extends HTMLElement {
  constructor() {
    super();
    this.onCountryChange = this.onCountryChange.bind(this);
  }

  connectedCallback() {
    this.countryElement = this.querySelector('[name="address[country]"]');
    console.log(this.countryElement);
    this.provinceElement = this.querySelector('[name="address[province]"]');

    if (this.countryElement) {
      this.countryElement.addEventListener("change", this.onCountryChange);

      const initialCountry = this.getAttribute("country") || "";
      if (initialCountry) {
        this.selectCountry(initialCountry);
      } else {
        this.onCountryChange();
      }
    }
  }

  disconnectedCallback() {
    if (this.countryElement) {
      this.countryElement.removeEventListener("change", this.onCountryChange);
    }
  }

  selectCountry(countryName) {
    const countryIndex = Array.from(this.countryElement.options).findIndex(
      (option) => option.textContent === countryName,
    );
    this.countryElement.selectedIndex = Math.max(0, countryIndex);
    this.countryElement.dispatchEvent(new Event("change"));
  }

  onCountryChange() {
    const selectedOption =
      this.countryElement.options[this.countryElement.selectedIndex];
    const provinces = selectedOption
      ? JSON.parse(selectedOption.getAttribute("data-provinces"))
      : [];
    this.provinceElement.parentElement.hidden = provinces.length === 0;

    if (provinces.length > 0) {
      this.provinceElement.innerHTML = provinces
        .map(
          (data) =>
            `<option value="${data[0]}"${data[1] === this.getAttribute("province") ? " selected" : ""}>${data[1]}</option>`,
        )
        .join("");
    }
  }
}

if (!customElements.get("country-selector")) {
  customElements.define("country-selector", CountrySelector);
}

const localizationDropdownSelector =
  '.country-select [data-localization-toggle="dropdown"], .lang-select [data-localization-toggle="dropdown"]';

function closeLocalizationDropdowns(exceptToggle = null) {
  document.querySelectorAll(localizationDropdownSelector).forEach((toggle) => {
    if (toggle === exceptToggle) return;

    const menu = toggle.nextElementSibling;
    toggle.classList.remove("show");
    toggle.setAttribute("aria-expanded", "false");
    menu?.classList.remove("show");
  });
}

function initializeLocalizationDropdowns(root = document) {
  root.querySelectorAll(localizationDropdownSelector).forEach((toggle) => {
    if (toggle.dataset.localizationDropdownReady === "true") return;

    const menu = toggle.nextElementSibling;
    if (!menu?.classList.contains("dropdown-menu")) return;

    toggle.dataset.localizationDropdownReady = "true";
    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      const shouldOpen = !menu.classList.contains("show");
      closeLocalizationDropdowns(toggle);
      toggle.classList.toggle("show", shouldOpen);
      toggle.setAttribute("aria-expanded", shouldOpen ? "true" : "false");
      menu.classList.toggle("show", shouldOpen);
    });
  });
}

function setupLocalizationDropdowns() {
  initializeLocalizationDropdowns();

  if (window.localizationDropdownHandlersReady) return;
  window.localizationDropdownHandlersReady = true;

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".country-select, .lang-select")) {
      closeLocalizationDropdowns();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    const openToggle = Array.from(
      document.querySelectorAll(localizationDropdownSelector),
    ).find((toggle) => toggle.getAttribute("aria-expanded") === "true");
    closeLocalizationDropdowns();
    openToggle?.focus();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initializeLocalizationDropdowns(event.target);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", setupLocalizationDropdowns, {
    once: true,
  });
} else {
  setupLocalizationDropdowns();
}
